import React, { useState } from "react";

import AdminLogoHeader from "../../components/admin/AdminLogoHeader";
import JournalLinesForm from "../../components/admin/JournalLinesForm";
import LedgerEntries from "../../components/admin/LedgerEntries";

const GeneralLedger = () => {
  const [ledgerRefreshKey, setLedgerRefreshKey] = useState(0);

  const handleTransactionPosted = () => {
    setLedgerRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <AdminLogoHeader />
      <div className="max-w-7xl mx-auto p-6 space-y-6">
        <JournalLinesForm onPosted={handleTransactionPosted} />
        <LedgerEntries refreshKey={ledgerRefreshKey} />
      </div>
    </div>
  );
};

export default GeneralLedger;
